import { RoleEnum } from '@anecdotes/auth-core';
import { ExtendedUser, UserFacadeService } from '@anecdotes/identity';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ResourceType } from '@anecdotes/data-store';

@Injectable()
export class OwnersFacadeService {
  private staticRolesSet = new Set<string>(Object.values(RoleEnum));
  constructor(private userFacade: UserFacadeService) {}

  /**
   * The service returns available users for resource type based on users permissions
   * @param resourceType
   * @returns users that can be assigned as owner for specified resource type
   */
  getPossibleOwnersForResourceType(resourceType: ResourceType): Observable<ExtendedUser[]> {
    return this.userFacade.getUsers().pipe(
      map((allUsers) => {
        if (resourceType === ResourceType.Risk) {
          const staticRolesSet = new Set<string>(Object.values(RoleEnum));
          const allowedRolesSet = new Set<string>([RoleEnum.Admin, RoleEnum.Manager, RoleEnum.Collaborator]);

          return allUsers.filter((user) => !staticRolesSet.has(user.role) || allowedRolesSet.has(user.role));
        }

        const filteredUsers = allUsers
          .map((user) => {
            if (
              [
                RoleEnum.Admin,
                RoleEnum.Collaborator,
                RoleEnum.Manager,
                RoleEnum.Contributor,
                RoleEnum.Viewer,
                RoleEnum.It,
                RoleEnum.Stakeholder,
              ].includes(user.role as RoleEnum)
            ) {
              return user;
            }

            if (this.isCustomRole(user.role)) {
              return user;
            }
          })
          .filter(Boolean);

        if (resourceType === ResourceType.Policy || resourceType === ResourceType.Uar) {
          return filteredUsers.filter(
            (user) =>
              user.role !== RoleEnum.Contributor &&
              user.role !== RoleEnum.Viewer &&
              user.role !== RoleEnum.It &&
              user.role !== RoleEnum.Stakeholder,
          );
        }

        return filteredUsers;
      }),
    );
  }

  private isCustomRole(role: string): boolean {
    return !this.staticRolesSet.has(role);
  }
}
